// extracted by css-extract-rspack-plugin
export default {"body":"FeedbackDialog-module__body__bTCvN","intro":"FeedbackDialog-module__intro__OKupG","textarea":"FeedbackDialog-module__textarea__W7SIy"};